import React, { useEffect } from "react";
import {
  Row,
  Form,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalTitle,
  Nav,
  Navbar,
  NavDropdown,
  Col,
} from "react-bootstrap";
import Logo from "../../img/Logo.svg";
import ModalHeader from "react-bootstrap/esm/ModalHeader";
import NavbarCollapse from "react-bootstrap/esm/NavbarCollapse";
import { Link } from "react-router";
import { PubSub } from "../../helper/pubSub";
import { useAlertHelpers } from "../../helper/Hooks/useAlertHelpers";
import { setPassword } from "../../services/postFunctions";
import { useAuth } from "../../contexts/AuthContext";
// icons
import { BiClinic, BiLock, BiShow, BiHide } from "react-icons/bi";
import { FaUserCircle } from "react-icons/fa";
import { GoSignOut } from "react-icons/go";
import { usePartialState } from "../../helper/Hooks/usePartialState";

interface NavigatorBarState {
  modalOpen: boolean;
  hiddenOldPw: boolean;
  hiddenNewPw: boolean;
  hiddenNewConfirmedPw: boolean;
  old_password: string;
  new_password: string;
  confirmed_new_password: string;
  childrenPathname: string;
}

const NavigationBar = () => {
  const { showAlertModal } = useAlertHelpers();
  const { state: authState, logout } = useAuth();

  const initialState: NavigatorBarState = {
    modalOpen: false,
    hiddenOldPw: true,
    hiddenNewPw: true,
    hiddenNewConfirmedPw: true,
    old_password: "",
    new_password: "",
    confirmed_new_password: "",
    childrenPathname: "",
  };

  const [state, updateState] = usePartialState(initialState);

  useEffect(() => {
    console.log("Geladen", window.location.pathname);
    updateState({
      childrenPathname: window.location.pathname,
    });
  }, [updateState]);

  /**Set modalOpen on false, if the modal is closed. */
  const closeModal = () =>
    updateState({
      modalOpen: false,
      old_password: "",
      new_password: "",
      confirmed_new_password: "",
    });

  /**Change hiddenPw state on true or false. */
  const showPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    console.log("Event: ", event);
    const target = event.currentTarget as HTMLElement;
    switch (target.id) {
      case "show1":
        updateState({ hiddenOldPw: false });
        break;
      case "hide1":
        updateState({ hiddenOldPw: true });
        break;
      case "show2":
        updateState({ hiddenNewPw: false });
        break;
      case "hide2":
        updateState({ hiddenNewPw: true });
        break;
      case "show3":
        updateState({ hiddenNewConfirmedPw: false });
        break;
      case "hide3":
        updateState({ hiddenNewConfirmedPw: true });
        break;
      default:
        break;
    }
  };

  /**Method for handle the password change.
   * If the new_password === confirmed_new_password, then the input data are stringified to JSON.
   * Then send JSON to backend api.
   */
  const handlePasswordChange = (event: React.SubmitEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (state.new_password !== state.confirmed_new_password) {
      showAlertModal(
        "Das neue Passwort und das bestätigte Passwort stimmen nicht überein.",
      );
    } else {
      const passwordData = {
        new_password: state.new_password,
        old_password: state.old_password,
        confirmed_new_password: state.confirmed_new_password,
      };

      try {
        setPassword(passwordData)
          .then((response) => {
            console.log("Response:", response.status);
            showAlertModal("Das Passwort wurde erfolgreich geändert.");
            closeModal();
          })
          .catch((error) => {
            if (
              error.response.status === 400 &&
              error.response.data.detail === "Invalid Old Password"
            ) {
              showAlertModal(
                "Die Eingabe des alten Passworts war leider nicht korrekt.",
              );
              console.error("Wrong old password", error);
            } else if (
              error.response.status === 400 &&
              error.response.data.detail === "Invalid request content."
            ) {
              showAlertModal(
                "Das von Ihnen gewählte Passwort entspricht nicht den Passwort-Anforderungen. Ihr Passwort wurde nicht geändert. Bitte wählen Sie ein Passwort, das folgende Anforderungen erfüllt: Mind. 10 Zeichen. Mind. 1 Kleinbuchstabe, 1 Großbuchstabe und 1 Zahl.",
              );
              console.error("Change Password Fail: ", error);
            } else {
              showAlertModal(
                "Irgendetwas ist schief gelaufen. Ihr Passwort wurde nicht geändert.",
              );
            }
          });
      } catch (e) {
        console.error("Catch", e);
        return;
      }
    }
  };

  const handleLogout = () => {
    if (typeof logout === "function") {
      logout();
    }
  };

  return (
    <>
      {authState?.userInfo ? (
        <Navbar
          className="border-bottom w-100 p-0"
          role="banner"
          style={{ height: "50px" }}
        >
          <Navbar.Brand className="col-2 col-md-2 col-xl-2 mw-100 h-100 p-0">
            <Link
              className="w-100 h-100 d-flex justify-content-center"
              to={{
                pathname:
                  authState?.userInfo.userType === "clinician"
                    ? "/clinician"
                    : authState?.userInfo.userType === "admin"
                      ? "/admin"
                      : "/patients",
              }}
              onClick={() => {
                PubSub.getInstance().publishToTopic("open-sidebar-submenu", {
                  menuName: "current",
                });
                PubSub.getInstance().publishToTopic("close-sidebar-submenus", {
                  closeAll: true,
                });
              }}
            >
              <img
                src={Logo}
                className="my-auto mw-100 mh-100 align-self-center"
                alt="Logo: Zur Startseite"
                title="Zur Startseite"
              />
            </Link>
          </Navbar.Brand>
          {/* User-Dropdown */}
          <NavbarCollapse id="">
            <Nav className="ms-auto">
              <NavDropdown
                align={"end"}
                className="nav-link navbar-dropdown"
                id="navbar-profile-menu"
                title={
                  <span>
                    <i className="mdi">
                      <FaUserCircle />
                    </i>
                    <span> {authState?.userInfo.userName}</span>
                  </span>
                }
              >
                <NavDropdown.Item>
                  <BiClinic /> Klinik:{" "}
                  {authState?.userInfo.clinicName ??
                    authState?.userInfo.clinicId}
                </NavDropdown.Item>
                {["clinician", "admin"].includes(
                  authState?.userInfo.userType ?? "",
                ) ? (
                  <NavDropdown.Item
                    onClick={() => updateState({ modalOpen: true })}
                  >
                    <BiLock /> Passwort ändern
                  </NavDropdown.Item>
                ) : null}

                <NavDropdown.Item onClick={handleLogout}>
                  <GoSignOut /> Abmelden
                </NavDropdown.Item>
              </NavDropdown>
            </Nav>
          </NavbarCollapse>
        </Navbar>
      ) : null}

      {/* password change Modal */}
      <Modal
        // size="md"
        backdrop="static"
        show={state.modalOpen}
        onHide={closeModal}
      >
        <ModalHeader closeButton>
          <ModalTitle>Passwort ändern</ModalTitle>
        </ModalHeader>
        <ModalBody>
          <Form noValidate onSubmit={handlePasswordChange}>
            <Form.Group as={Row} className="mb-3">
              <Col sm="4">
                <Form.Label>Altes Passwort</Form.Label>
              </Col>
              <Col sm="6">
                <Form.Control
                  className="form-control"
                  type={state.hiddenOldPw ? "password" : "text"}
                  value={state.old_password}
                  onChange={(text) =>
                    updateState({ old_password: text.target.value })
                  }
                ></Form.Control>
              </Col>
              <Col>
                <div className="passwordShow">
                  {state.hiddenOldPw ? (
                    <Button
                      className="passwordShow"
                      variant=""
                      id="show1"
                      onClick={showPassword}
                    >
                      <BiShow className="hideShowPw hideShowNav" id="show1" />
                    </Button>
                  ) : (
                    <Button
                      className="passwordShow"
                      variant=""
                      id="hide1"
                      onClick={showPassword}
                    >
                      <BiHide className="hideShowPw hideShowNav" id="hide1" />
                    </Button>
                  )}
                </div>
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
              <Col sm="4">
                <Form.Label>Neues Passwort</Form.Label>
              </Col>
              <Col sm="6">
                <Form.Control
                  className="form-control"
                  type={state.hiddenNewPw ? "password" : "text"}
                  value={state.new_password}
                  onChange={(text) =>
                    updateState({ new_password: text.target.value })
                  }
                />
                <Form.Text className="text-muted">
                  Mind. 10 Zeichen. Mind. 1 Kleinbuchstabe, 1 Großbuchstabe und
                  1 Zahl.
                </Form.Text>
              </Col>
              <Col sm="2">
                <div>
                  {state.hiddenNewPw ? (
                    <Button
                      className="passwordShow"
                      variant=""
                      id="show2"
                      onClick={showPassword}
                    >
                      <BiShow className="hideShowPw hideShowNav" id="show2" />
                    </Button>
                  ) : (
                    <Button
                      className="passwordShow"
                      variant=""
                      id="hide2"
                      onClick={showPassword}
                    >
                      <BiHide className="hideShowPw hideShowNav" id="hide2" />
                    </Button>
                  )}
                </div>
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
              <Col sm="4">
                <Form.Label>Neues Passwort bestätigen</Form.Label>
              </Col>
              <Col sm="6">
                <Form.Control
                  className="form-control"
                  type={state.hiddenNewConfirmedPw ? "password" : "text"}
                  value={state.confirmed_new_password}
                  onChange={(text) =>
                    updateState({ confirmed_new_password: text.target.value })
                  }
                />
              </Col>
              <Col sm="2">
                <div>
                  {state.hiddenNewConfirmedPw ? (
                    <Button
                      className="passwordShow"
                      variant=""
                      id="show3"
                      onClick={showPassword}
                    >
                      <BiShow className="hideShowPw hideShowNav" id="show3" />
                    </Button>
                  ) : (
                    <Button
                      className="passwordShow"
                      variant=""
                      id="hide3"
                      onClick={showPassword}
                    >
                      <BiHide className="hideShowPw hideShowNav" id="hide3" />
                    </Button>
                  )}
                </div>
              </Col>
            </Form.Group>
            <Button className="btn-custom" type="submit">
              Ändern
            </Button>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button variant="danger" onClick={closeModal}>
            Abbrechen
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default NavigationBar;
